import Link from 'next/link'
import { trackMxEvent } from '@/utils/mixpanel'
import { cn } from '@/lib/utils'

interface Props {
  title: string
  slug: string
  disabled?: boolean
}

const CategoryListItem = ({ title, slug, disabled = false }: Props) => (
  <Link
    href={`/cat/${slug}`}
    className={cn('block rounded-md border border-border bg-background p-6 transition-colors hover:border-primary', { 'pointer-events-none': disabled })}
    onClick={() => trackMxEvent('Search Category Click', {
      category_name: title,
      category_slug: slug,
    })}
  >
    <span className="text-sm font-medium md:text-base">
      {title}
    </span>
  </Link>
)

export default CategoryListItem
